import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";

export const GetInternalUsersCON = (page, limit, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getInternalUsersCON(page, limit);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_INTERNAL_USERS_CON, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};